import DriveFileMoveOutlined from "@mui/icons-material/DriveFileMoveOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { MoveProgramDialog } from "./move-program-dialog";

import type { ProgramNode, ProgramTree } from "../../program-tree/program-tree";
import type { FC } from "react";

/** The More actions menu of a program's page, to move the program or folder. Only for an admin. */
export const ProgramActionsMenu: FC<{
  tree: ProgramTree;
  program: ProgramNode;
  /** After it moves, and after it moves back, so that the programs can load again. */
  onMoved: () => void;
}> = ({ tree, program, onMoved }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const [moving, setMoving] = useState(false);

  return (
    <>
      <IconButton
        aria-label="More actions"
        aria-haspopup="menu"
        aria-expanded={anchor !== null}
        onClick={(event) => setAnchor(event.currentTarget)}
        data-analytics-id="program-page-more"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchor} open={anchor !== null} onClose={() => setAnchor(null)}>
        <MenuItem
          onClick={() => {
            setAnchor(null);
            setMoving(true);
          }}
          data-analytics-id="program-page-move"
        >
          <ListItemIcon>
            <DriveFileMoveOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>{program.parent_id ? "Move folder…" : "Move program…"}</ListItemText>
        </MenuItem>
      </Menu>
      <MoveProgramDialog
        open={moving}
        onClose={() => setMoving(false)}
        tree={tree}
        program={program}
        onMoved={onMoved}
      />
    </>
  );
};
